import React from 'react';
export function DescriptionSection() {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 md:p-10 mb-12" data-id="element-1906">
      <div className="max-w-4xl mx-auto space-y-6 text-gray-700 text-lg leading-relaxed" data-id="element-1907">
        <p data-id="element-1908">
          CHMER HM Series high speed milling machines for graphite and hard
          metal machining, available in ball screw (HM43T, HM65T) and linear
          motor (HM4030L, HM6050L) configurations with dust-free options. Also
          featuring EDMMax Diamond Abrasive Saws for precision cutting of
          non-conductive materials.
        </p>
      </div>
    </div>;
}